import { IPrecisionSite } from '../creneaux/precision-site.interface';
import { ISite } from '../creneaux/site.interface';
import { Site } from '../creneaux/site.model';
import { FilePath } from '../dto/file-path.dto';
import { CreneauGardiennageImported, ICreneauGardiennageImported } from './creneau-gardiennage-imported.model';
import { HistoriqueRefus } from './historique-refus.model';
import { IPrecisionIntervention } from './precision-intervention';
import { UserDTO } from './user.dto';

export class InterPonctuelleForResponsableDTO {
  constructor(
    public prestationId: string,
    public prestationLibelle: string,
    public prestationReference: string,
    public affectationId: string,
    public date: Date,
    public clientLibelle: string,
    public site: ISite,
    public origine: string,
    public origineDetails: string,
    public consignes: string,
    public isWaitingCallback: boolean,
    public attribuee: boolean,
    public reference?: string,
    public client?: string,
    public clientPhoto?: FilePath,
    public contexte?: string,
    public nbAlertes?: number,
    public alertesNonLues?: boolean,
    public autorisationPenetrerInterieurBatiment?: boolean,
    public autorisationPenetrerEspacesExterieurCloture?: boolean,
    public autorisationPenetrerEspacesCommun?: boolean,
    public autorisationPenetrer?: boolean,
    public affectee?: Date,
    public acceptee?: Date,
    public demarree?: Date,
    public terminee?: Date,
    public cloturee?: Date,
    public refusedBy?: string,
    public refusedDate?: Date,
    public refusedReason?: string,
    public agent?: UserDTO,
    public historiqueRefus?: HistoriqueRefus[],
    public gardiennage?: ICreneauGardiennageImported,
    public precisions?: IPrecisionIntervention[],
    public precisionSite?: IPrecisionSite
  ) {}

  public static hydrate(obj: InterPonctuelleForResponsableDTO): InterPonctuelleForResponsableDTO {
    return new InterPonctuelleForResponsableDTO(
      obj.prestationId,
      obj.prestationLibelle,
      obj.prestationReference,
      obj.affectationId,
      new Date(obj.date),
      obj.clientLibelle,
      Site.hydrate(obj.site),
      obj.origine,
      obj.origineDetails,
      obj.consignes,
      obj.isWaitingCallback,
      obj.attribuee,
      obj.reference,
      obj.client,
      obj.clientPhoto ? FilePath.hydrate(obj.clientPhoto) : undefined,
      obj.contexte,
      obj.nbAlertes,
      obj.alertesNonLues,
      obj.autorisationPenetrerInterieurBatiment,
      obj.autorisationPenetrerEspacesExterieurCloture,
      obj.autorisationPenetrerEspacesCommun,
      obj.autorisationPenetrer,
      obj.affectee ? new Date(obj.affectee) : undefined,
      obj.acceptee ? new Date(obj.acceptee) : undefined,
      obj.demarree ? new Date(obj.demarree) : undefined,
      obj.terminee ? new Date(obj.terminee) : undefined,
      obj.cloturee ? new Date(obj.cloturee) : undefined,
      obj.refusedBy,
      obj.refusedDate ? new Date(obj.refusedDate) : undefined,
      obj.refusedReason,
      obj.agent ? UserDTO.hydrate(obj.agent) : undefined,
      obj.historiqueRefus ? obj.historiqueRefus.map(HistoriqueRefus.hydrate) : undefined,
      obj.gardiennage ? CreneauGardiennageImported.hydrate(obj.gardiennage) : undefined,
      obj.precisions,
      obj.precisionSite
    );
  }
}
